import { IAdvertChannelRepository } from '../../ports/IAdvertChannelRepository';

export class GetAdvertChannelsUseCase {
  constructor(private repo: IAdvertChannelRepository) {}
  execute(advertUUID: string) { return this.repo.getByAdvert(advertUUID); }
}
